<template>
  <b-card>
    <template #header>
      <b-row class="mt-2">
        <b-col class="text-right">
          <b-button class="btn-sm" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.userdata_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-collapse id="userdata_search_collapse" class="mt-2">
            <UserDataFiltering :getPage="getItems"></UserDataFiltering>
          </b-collapse>
        </b-col>
      </b-row>
    </template>
    <b-row>
      <b-col cols="12" v-if="isLoading">
        <Loader></Loader>
      </b-col>
        <b-col v-else cols="12">
          <table class="table table-sm table-striped table-hover">
            <thead>
            <tr>
              <th>{{$t('views.userdata.list.nameAndSurname')}}</th>
              <th>{{$t('views.userdata.show.hiredIn')}}</th>
              <th>{{$t('views.userdata.list.mobilePhone')}}</th>
              <th>{{$t('views.userdata.list.userEmail')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="item in items"
              :key="item['@id']">
              <td>
                {{ item.employee.fullName }}
              </td>
              <td>
                {{ item.firm.firmname1 || item.firm.firmname2 }}
              </td>
              <td>
                <phoneNumberLink :phoneNumber="item.employee.mobilePhone"/>
              </td>
              <td>
                <a :href="'mailto: ' + item.employee.userEmail">{{ item.employee.userEmail }}</a>
              </td>
            </tr>
            </tbody>
          </table>
        </b-col>
      <Pagination v-if="view"
      :view="view"
      @getPage="getPage($event)"
      ></Pagination>
      </b-row>
  </b-card>
</template>

<script>
import Loader from '@/components/Dashboard/Layout/Loader'
import UserDataFiltering from '@/components/Dashboard/Views/userdata/component/UserDataFiltering/UserDataFiltering'
import ApiService from '@/utils/ApiService'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'

export default {
  name: 'UserDataEmploteesList',
  components: {
    PhoneNumberLink,
    Loader,
    UserDataFiltering,
    Pagination
  },
  data () {
    return {
      view: {},
      isLoading: true,
      items: []
    }
  },
  created () {
    this.getItems()
  },
  methods: {
    getPage (page) {
    },
    async getItems () {
      const response = await new ApiService('user_data_employees').getResults()
      this.isLoading = false
      this.items = response.items
      this.view = response.view
    }
  }
}
</script>
